export default {
  default: () => import("/Users/abdalrahmansaadulla/Desktop/website/layouts/default.vue").then(m => m.default || m)
}